  <button
    mat-icon-button
    type="button"
  [disabled]="disabled"
    (click)="click()">

    <mat-icon
      [class]="iconClass">
      {{ icon }}
    </mat-icon>

  </button>

<!-- @if (iconType === 'material') {
  <mat-icon [ngClass]="iconClass">
    {{ icon }}
  </mat-icon>
}

@if (iconType === 'fontawesome') {
  <i
    [ngClass]="icon + ' ' + iconClass"
    aria-hidden="true">
  </i>
} -->

